export type CampaignQuoteTemplateItemAutoPriceUpdateModel = {
  from?: number,
  to?: number,
  at?: string,
  updated?: boolean,
  seen?: boolean,
}

export type CampaignQuoteTemplateItemDataModel = {
  agency_price?: number,
  default_quote_item_id?: number,
  price_auto_updated_seen?: boolean,
  price_auto_updated?: boolean,
  price_auto_updated_at?: string,
  hidden?: boolean,
  publication_week?: number,
  tags?: string[],
  auto_price_update?: CampaignQuoteTemplateItemAutoPriceUpdateModel,
}

export type CampaignQuoteTemplateItemModel = {
  base_price?: number,
  cache_key?: number,
  campaign_quote_template_id?: number,
  campaign_quote_template_section_id?: number,
  compulsory?: boolean,
  data?: CampaignQuoteTemplateItemDataModel,
  description?: string,
  display_options?: any,
  display_title?: string,
  id: number,
  internal_notes?: string,
  item_category?: string,
  item_type?: 'custom' | 'orderable',
  locked?: boolean,
  options?: any,
  options_string?: string,
  order_bundle_id?: number,
  package_id?: number,
  paid_by?: string,
  price: number,
  price_override?: number,
  price_type?: 'fixed' | 'percentage',
  processing_fee?: number,
  provider_id?: number,
  provider_price_list_item_id?: number,
  publication_edition_id?: number,
  publication_id?: number,
  publication_package_id?: number,
  quantity?: number,
  quote_total?: number,
  quote_template_dynamic_items?: any,
  required_by?: string,
  required_days_from_start?: number,
  row_title?: string,
  selected?: boolean,
  service_id?: number,
  service_product_id?: number,
  sort?: number,
  tax_rate?: number,
  title: string,
  type?: 'CampaignQuoteTemplateItem',
  edition?: any,
  publication?: any,
}

const state = {
  base_price: undefined,
  campaign_quote_template_id: undefined,
  campaign_quote_template_section_id: undefined,
  compulsory: false,
  data: {
    agency_price: undefined,
    default_quote_item_id: undefined,
    hidden: false,
    publication_week: undefined,
    tags: [],
  },
  description: '',
  display_title: '',
  id: undefined,
  internal_notes: undefined,
  item_type: undefined,
  locked: false,
  options: undefined,
  options_string: undefined,
  order_bundle_id: undefined,
  package_id: undefined,
  price: '',
  price_type: 'fixed',
  price_override: '',
  processing_fee: undefined,
  provider_id: undefined,
  provider_price_list_item_id: undefined,
  publication_edition_id: undefined,
  publication_id: undefined,
  publication_package_id: undefined,
  quantity: undefined,
  required_by: undefined,
  required_days_from_start: undefined,
  row_title: undefined,
  selected: true,
  service_id: undefined,
  service_product_id: undefined,
  sort: undefined,
  title: undefined,
}

export const requiredFields = [
  { key: 'campaign_quote_template_id' },
  { key: 'campaign_quote_template_section_id' },
  { key: 'price', validation: (price: string) => price !== '' && !Number.isNaN(Number(price)) },
  { key: 'title' },
]

export default state
